import { createApp } from "vue";
import Home from "../../../views/lp01/Home";
import store from "../../../store";

createApp(Home).use(store).mount("#app");
